var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Game")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Rules")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }